import { FilterCriteria } from 'app/models/dto/filter-criteria.model';

export class BorrowerIndexGet {
	static readonly type = '[BorrowerIndex] BorrowerIndexGet';
	constructor() {}
}

export class ClearBorrowerIndexStore {
	static readonly type = '[BorrowerIndex] ClearBorrowerIndexStore';
	constructor() {}
}

export class BorrowerIndexApplyFilter {
	static readonly type = '[BorrowerIndex] BorrowerIndexApplyFilter';
	constructor(
		public relationCriteria: {},
		public criteria: FilterCriteria,
		public filterParameters
	) {}
}

export class BorrowerIndexUpdateLoadingState {
	static readonly type = '[BorrowerIndex] BorrowerIndexUpdateLoadingState';
	constructor(public loading: boolean) {}
}

export class BorrowerIndexApplySort {
	static readonly type = '[BorrowerIndex] BorrowerIndexApplySort';
	constructor(public attribute: string, public direction: 'asc' | 'desc') {}
}

export class BorrowerIndexNextPage {
	static readonly type = '[BorrowerIndex] BorrowerIndexNextPage';
	constructor() {}
}
